export { default } from 'common/utils/validate-and-map';
